module.exports = __webpack_public_path__ + "img/gb91_1986.prt.b97613fc.jpg";